import { render } from "./backlog.vue?vue&type=template&id=6f0848cc&ts=true"
import script from "./backlog.vue?vue&type=script&lang=ts"
export * from "./backlog.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__